// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__nUzii","modal":"style_modal__9+ghn","title":"style_title__QlB2w","overlay_close":"style_overlay_close__rfZer"};